module.exports = __webpack_public_path__ + "static/img/gift-box-for-modal.f3ea528.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gift-box-for-modal.svg
// module id = Qxev
// module chunks = 1